<template>
    <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
        <transition-group name="breadcrumb">
            <el-breadcrumb-item v-for="(item,i)  in nav" :key="item.title">
                <span v-if="i==nav.length-1" class="no-redirect">{{item.title}}</span>
                <router-link v-else :to="item.path">{{item.title}}</router-link>
            </el-breadcrumb-item>
        </transition-group>
    </el-breadcrumb>
</template>


<script>
export default {
    data() {
        return {
            levelList: null,
        };
    },
    props: ["navSource"],
    created() {
       if(this.$route.path.includes('apply/'))  {
           this.levelList = [
                { title: "综合查询", path: "/apply" },
                { title: "院校查询", path: "/apply/search" }
           ]
       } else {
           this.levelList = [
                { title: "院校信息", path: "/" },
                { title: "院校管理", path: "/colleges" }
           ]
       }
        
    },
    computed:{
        nav(){
            if(this.navSource) {
                return this.levelList.concat(this.navSource);
            }
        }
    }
};
</script>

<style lang="less" scoped>
.app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    .no-redirect {
        color: #97a8be;
        cursor: text;
    }
}
</style>
